<template>
  <div class="body-wrapper">
    <Header :title="'Exercises'" />
    <div class="exercise-filters">
      <div class="search-field">
        <input 
          type="text" 
          placeholder="Search..." 
          v-model="searchFilter"/>
      </div>
      <div class="spacer"></div>
      <select v-model="videoFilter">
        <option value="">All</option>
        <option value="video">Video attached</option>
        <option value="no-video">No video attached</option>
      </select>
      <select v-model="primaryMuscleFilter">
        <option value="">All Prime Muscles</option>
        <option 
          v-for="muscle in filters.body_parts" 
          :key="muscle['option']"
          :value="muscle['option']">{{muscle['option']}}</option>
      </select>
      <select v-model="equipmentFilter">
        <option value="">All Equipment</option>
        <option 
          v-for="equipment in filters.equipment" 
          :key="equipment['label']"
          :value="equipment['label']">{{equipment['label']}}</option>
      </select>
      <button 
        class="secondary-btn-dark"
        @click="createExercise = true;">CREATE NEW EXERCISE</button>
    </div>

    <DataTable 
      url="/v1/manage_exercises"
      :fields="fields"
      :extraParams="extraParams"
      :options="actionOptions"      
      @details-clicked="detailsClicked" />


    <AddExerciseModal
      v-if="createExercise"
      :equipment="filters.equipment"/>

    <ExerciseDetailModal
      v-if="viewExerciseDetails"/>
  </div>
</template>

<script>
import Header from "@/components/header/Header";
import { getFilters } from '@/api/requests';
import DataTable from '../components/table/DataTable.vue';
import AddExerciseModal from '../components/modals/AddExerciseModal.vue';
import ExerciseDetailModal from '../components/modals/ExerciseDetailModal.vue';

export default {
  name: 'Workouts',
  
  components: {
    Header,
    DataTable,
    AddExerciseModal,
    ExerciseDetailModal
  },

  data() {
    return {
      videoFilter: '',
      primaryMuscleFilter: '',
      equipmentFilter: '',
      searchFilter: '',
      exercises: [],
      filters: {
        body_parts: [],
        equipment: [],
      },
      actionOptions: [
        {
          name: 'View details',
          action: 'loadExerciseDetails',
        },
        {
          name: 'Edit details',
          action: 'editExerciseDetails',
        },
        {
          type: 'divider'
        },
        {
          name: 'Delete',
          action: 'deleteExercise',
        },
      ],
    };
  },
  
  mounted() {
    getFilters().then(response => {
      this.filters = response.data;
    }).catch(() => {
      // TODO errors
    });
  },

  methods: {
    detailsClicked(value) {
      this.$store.dispatch('exercise/exerciseClicked', value);
    },
  },

  computed: {
    fields() {
      return [
        {
          name: 'title-slot',
          title: 'Exercise name',
          sortField: 'title',
          width: '20%'
        },
        {
          name: 'muscles',
          title: 'Primary',
          sortField: 'body_part_id'
        },
        {
          name: "secondary-slot",
          title: 'Seconday',
          width: '40%'
        },
        {
          name: 'equipment',
          title: 'Equipment',
          sortField: 'equipment'
        },
        {
          name: 'exercise_type',
          title: 'Type',
          sortField: 'exercise_type'
        },
        {
          name: 'assisted',
          title: 'Assisted',
          sortField: 'assisted'
        },
        {
          name: 'completed',
          title: 'Completed',
          sortField: 'completed',
        },
        {
          name: 'video-slot',
          title: 'Video',
        },
        {
          name: 'requests',
          title: 'Vid Requests',
          sortField: 'requests'
        },
        {
          name: 'exercise-actions-slot',
          title: '',
        }
      ]
    },

    extraParams() {
      return {
        'video_filter': this.videoFilter,
        'muscle_groups': this.primaryMuscleFilter,
        'equipment': this.equipmentFilter,
        'search': this.searchFilter
      };
    },

    createExercise: {
      get () {
        return this.$store.state.exercise.createExercise
      },
      set (value) {
        this.$store.commit('exercise/updateAttribute', {value: value, type: 'createExercise'})
      }
    },

    viewExerciseDetails: {
      get () {
        return this.$store.state.exercise.viewExerciseDetails
      },
      set (value) {
        this.$store.commit('exercise/updateAttribute', {value: value, type: 'viewExerciseDetails'})
      }
    },

  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";
@import "@/assets/css/internal";

.exercise-filters {
  display: flex;
  justify-content: flex-start;
  padding: $spacing-base;
  padding-top: $spacing-base;
  gap: $spacing-small;

  .spacer {
    flex: 1;
  }

  input {
    height: 28px;
    width: 300px;
  }

  select {
    height: 28px;
    width: 150px;
    background-image: linear-gradient(45deg, transparent 50%, gray 50%),
    linear-gradient(135deg, gray 50%, transparent 50%),
    linear-gradient(to right, #ccc, #ccc);
    background-position: calc(100% - 10px) calc(0.7em + 4px),
    calc(100% - 5px) calc(0.7em + 4px),
    calc(100% - 2.5em) 0.5em;
    background-size: 5px 5px, 5px 6px, 0px 3em;
  }

  .secondary-btn-dark {
    border-color: #FFF;
    color: #FFF;
    font-size: 12px;
    height: 28px;
    width: auto;
  }
}
</style>
